<div class="d-lg-block d-none">
  <fgb-banner [title]="'contact.us.page.title' | translate"></fgb-banner>
</div>

<div class="d-lg-none">
  <fgb-mobile-page-header
    pageTitle="contact.us.page.title"
    [showFooter]="true"
    [showQr]="false"
    [showBalance]="false"
    [backButtonLink]="'/'"
  ></fgb-mobile-page-header>
</div>

<fgbcl-contact-us></fgbcl-contact-us>
